import { ElementRef, ViewContainerRef, Renderer2, ComponentFactoryResolver, ReflectiveInjector } from '@angular/core';
import { Injectable } from '@angular/core';
import { IComponentData } from '../models/dynamic-component/IComponentData';

@Injectable({
  providedIn: 'root'
})
export class DynamicComponentService {

  constructor() { }

    addDynamicComponent(
        componentdata: any,
        ele: ElementRef,
        vcr: ViewContainerRef,
        componentFactoryResolver: ComponentFactoryResolver,
        renderer: Renderer2,
    ) {
        if (componentdata) {
            if (componentdata.component !== null) {
                const componentFactory = componentFactoryResolver.resolveComponentFactory(componentdata.component);
                const inputProviders = Object.keys(componentdata.inputs).map((inputName) => {
                    return {
                        provide: inputName,
                        useValue: componentdata.inputs[inputName]
                    };
                });

                // tslint:disable-next-line: deprecation
                const injector = ReflectiveInjector.resolveAndCreate([
                    {
                        provide: inputProviders,
                        useValue: {
                            host: ele.nativeElement
                        }
                    }
                ]);

                const componentRef = vcr.createComponent(componentFactory, 0, injector);
                (<IComponentData>componentRef.instance).inputs = componentdata.inputs;
                componentRef.changeDetectorRef.detectChanges();
                renderer.appendChild(ele.nativeElement, componentRef.location.nativeElement);
                return componentRef;
            }
        }
    }

    addDynamicComponent2(
        componentdata: any,
        vcr: ViewContainerRef,
        componentFactoryResolver: ComponentFactoryResolver,
    ) {
        if (componentdata) {
            if (componentdata.component !== null) {
                // Give you access to the inputs inside the component
                const inputProviders = Object.keys(componentdata.inputs).map((inputName) => {
                    return {
                        provide: inputName,
                        useValue: componentdata.inputs[inputName]
                    };
                });

                // tslint:disable-next-line: deprecation
                const resolvedInputs = ReflectiveInjector.resolve(inputProviders);

                // This will prepare the inject of inputs on the factory
                // tslint:disable-next-line: deprecation
                const injector = ReflectiveInjector.fromResolvedProviders(resolvedInputs, vcr.parentInjector);

                // Creates a factory
                const factory = componentFactoryResolver.resolveComponentFactory(componentdata.component);

                // Here we inject the inputs on the factory
                const component = factory.create(injector);
                component.changeDetectorRef.detectChanges();
                // This will add the component in the DOM container
                vcr.insert(component.hostView);
            }
        }
    }
}
